import { LoginRequest, LoginResponse } from '../../types/api.types';


const MOCK_LOGINS: { credentials: LoginRequest; response: LoginResponse }[] = [
    {
        credentials: {
            email: 'tech.user@example.com',
            password: 'user123',
        },
        response: {
            message: 'Login successful',
            token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJmMzEwODQ3Zi0xODQyLTQ2OTUtYWYyNS1jMWU4MmY2ODFkNDEiLCJlbWFpbCI6InRlY2gudXNlckBleGFtcGxlLmNvbSIsInJvbGVJZCI6ImQ4YTJkNWI5LTUzNWItNGRiZi04NmM1LTU4Y2E3NDM4YTE3NyIsInJvbGVOYW1lIjoiVXNlciIsImlhdCI6MTc2OTYwMDMzOCwiZXhwIjoxNzY5Njg2NzM4fQ.2Z1TUlzqtr5imWjwKYX6u7yWeV5q7j8x9owZ8M64uqs',
            user: {
                id: 'f310847f-1842-4695-af25-c1e82f681d41',
                email: 'tech.user@example.com',
                isActive: true,
                role: {
                    name: 'User',
                    description: 'Regular user with basic access',
                },
                profile: {
                    fullName: 'Tech User',
                    email: 'tech.user@example.com',
                },
            },
        },
    },
    {
        credentials: {
            email: 'admin@example.com',
            password: 'admin123',
        },
        response: {
            message: 'Login successful',
            token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJlYjI3YzdlZS0wOTVkLTRmMjktYjY0YS05NzMwM2I0MzFlMTciLCJlbWFpbCI6ImFkbWluQGV4YW1wbGUuY29tIiwicm9sZUlkIjoiMmM5Yjc2ZDMtZDExMC00NTUyLThmMTctZWVlMmYxYThmZWZiIiwicm9sZU5hbWUiOiJBZG1pbiIsImlhdCI6MTc2OTYwMDQ4NCwiZXhwIjoxNzY5Njg2ODg0fQ._A5wjeKyUHTf_9l0FrwktEO5f-c9cbp8u_vIsosF3OM',
            user: {
                id: 'eb27c7ee-095d-4f29-b64a-97303b431e17',
                email: 'admin@example.com',
                isActive: true,
                role: {
                    name: 'Admin',
                    description: 'System administrator with full access',
                },
                profile: {
                    fullName: 'System Administrator',
                    email: 'admin@example.com',
                },
            },
        },
    },
];

export class AuthService {
    static async login(credentials: LoginRequest): Promise<LoginResponse> {
        const match = MOCK_LOGINS.find(
            ({ credentials: allowed }) =>
                allowed.email === credentials.email && allowed.password === credentials.password
        );

        if (!match) {
            // Mimic a typical login error without hitting an API
            return Promise.reject(new Error('Invalid email or password'));
        }

        // Return a cloned object to avoid accidental mutations
        return Promise.resolve(JSON.parse(JSON.stringify(match.response)));
    }

    static async logout(): Promise<void> {
        // Clear the token from localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        // Optional: If you have a logout endpoint on the server
        // await api.post('/auth/logout');
    }

    static isAuthenticated(): boolean {
        const token = localStorage.getItem('token');
        return !!token;
    }

    static getToken(): string | null {
        return localStorage.getItem('token');
    }

    static getCurrentUser() {
        const userData = localStorage.getItem('user');
        if (userData) {
            try {
                return JSON.parse(userData);
            } catch (error) {
                console.error('Error parsing user data:', error);
                return null;
            }
        }
        return null;
    }
}